export default {
  /**接口请求的基础路径 */
  baseUrl: {
    // dev: 'http://192.168.0.93:8080', // 开发路径
    dev: 'http://192.168.1.23:8088',
    // dev: 'http://10.0.0.147:8301',
    pro: 'http://192.168.1.23:8088', // 生产路径
  },
  AIurl: 'http://192.168.1.23:8088/api/writing/analyse',
  uploadUrl: 'http://192.168.1.23:8088/api/upload/image', //圖片上傳
}
